import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { parseParams } from "../../../helpers/clean-object";

import { UPDATE_SCAN } from "../scans.queries";
import { UpdateScanInput } from "../../../__generated__/globalTypes";
import {
  UpdateScanMutation,
  UpdateScanMutationVariables,
} from "../../../__generated__/UpdateScanMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateScan = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateScanInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateScanMutation,
    UpdateScanMutationVariables
  >(UPDATE_SCAN);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateScan?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateScan?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
